const generateRandomString = (length = 10) =>
  Math.random().toString(20).substr(2, length);

const MenuSvg = require("@/assets/Menu_Svg/Menu_Svg.js");

// Family Book Menu Master
// Family Menu - Home, Dashboard, Family Members, Family Tree

// Family Masters Child Items
const FamilyMasters_Child_ARR = [
  {
    id: generateRandomString(),
    name: "Birthdays",
    // svg_icon: MenuSvg.members,
    to: "/familybook/family_birthday",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_BIRTHDAY"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Anniversaries",
    // svg_icon: MenuSvg.members,
    to: "/familybook/family_anniversary",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_BIRTHDAY"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  
  {
    id: generateRandomString(),
    name: "Events",
    // svg_icon: MenuSvg.role,
    to: "/familybook/Family_event",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_EVENT"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Announcements",
    // svg_icon: MenuSvg._3DCube_Svg,
    to: "/familybook/Family_announcement",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_ANNOUNCEMENT"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Relation Master",
    // svg_icon: MenuSvg._3DCube_Svg,
    to: "/familybook/RelationMaster",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_RELATION_MASTER"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Meeting Type",
    // svg_icon: MenuSvg._3DCube_Svg,
    to: "/familybook/meeting_type",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_FAMILY_MEETING_TYPE"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Department",
    // svg_icon: MenuSvg._3DCube_Svg,
    to: "/familybook/department",
    has_children: false,
    screen_code: ["CREATE_MASTERS"],
    product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
    screen_codeflag: ["SCN_DEPARTMENT"],
    module_codeflag: ["MASTERS"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Designation",
    // svg_icon: MenuSvg._3DCube_Svg,
    to: "/familybook/designation",
    has_children: false,
    screen_code: ["CREATE_MASTERS"],
    product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
    screen_codeflag: ["SCN_DESIGNATION"],
    module_codeflag: ["MASTERS"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Forums Announcement Type",
    // svg_icon: MenuSvg._3DCube_Svg,
    to: "/familybook/Forums_announcement_type",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_FAMILY_MEETING_TYPE"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Forums Category",
    // svg_icon: MenuSvg._3DCube_Svg,
    to: "/familybook/Forums_category",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_FAMILY_MEETING_TYPE"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Company",
    // svg_icon: MenuSvg._3DCube_Svg,
    to: "/familybook/family_company",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_FAMILY_COMPANY"],
    module_codeflag: ["MASTERS"],
    underline: false,
    isnonadmintoshow: true,
  },
];

const TaskMasters_Child_ARR = [
  {
    id: generateRandomString(),
    // icon: "mdi-clipboard-edit",
    name: "My Checklist",
    to: "/familybook/checklist_new",
    has_children: false,
    underline: false,
    isnonadmintoshow: true,
    // screen_code: ["CREATE_CHK"],
    product_code: ["TECTALIK_CHCK"],
    screen_codeflag: ["SCN_CHCK_MY_CHECKLIST", "SCN_CHCK_CASE_BASED"],
    module_codeflag: ["COMPLIANCE"],
  },
  {
    id: generateRandomString(),
    name: "Forms",
    has_children: false,
    underline: false,
    isnonadmintoshow: true,
    // icon: "mdi-form-select",
    to: "/familybook/forms_master",
    screen_code: ["CREATE_MASTERS"],
    product_code: ["TECTALIK_CHCK"],
    screen_codeflag: ["SCN_BRANCH"],
    module_codeflag: ["MASTERS"],
  },
  {
    id: generateRandomString(),
    name: "Tasks",
    // svg_icon: MenuSvg.task,
    to: "/familybook/MyTasks",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    // icon: "mdi-alpha-r-box",
    name: "Reports",
    to: "/familybook/showlist_all_report",
    has_children: false,
    // screen_code: ["RUN_REPORTS"],
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_CHCK_REPORTS"],
    module_codeflag: ["COMPLIANCE"],
    underline: false,
    isnonadmintoshow: true,
  },
];

const Tickets_Child_ARR = [
  {
    id: generateRandomString(),
    name: "Tickets",
    // svg_icon: MenuSvg.ticket,
    to: "/familybook/ticket",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    // icon: "mdi-alpha-r-box",
    name: "Reports",
    to: "/familybook/tickets_report",
    screen_code: ["RUN_REPORTS"],
    product_code: ["TECTALIK_TKT"],
    screen_codeflag: ["SCN_TKT_REPORTS"],
    module_codeflag: ["TICKETS"],
    underline: false,
    isnonadmintoshow: true,
  },

]

const FamilyBook_Masters_Child_ARR = [
  // {
  //   id: generateRandomString(),
  //   name: "Company",
  //   child: true,
  //   // icon: "mdi-domain",
  //   to: "/familybook/company_master",
  //   has_children: false,
  //   screen_code: ["CREATE_MASTERS"],
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_FAMILY_COMPANY"],
  //   module_codeflag: ["MASTERS"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // }
];

// Family Sub Menu Items
const Family_Child_ARR = [
  {
    id: generateRandomString(),
    name: "Family Tree",
    svg_icon: MenuSvg.Family_tree,
    to: "/familybook/family_tree",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  // {
  //   id: generateRandomString(),
  //   name: "Family Meetings",
  //   svg_icon: MenuSvg.meeting,
  //   to: "/familybook/family_meetings_landing",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   name: "Votes & Polls",
  //   svg_icon: MenuSvg.vote,
  //   to: "/familybook/familyvotes",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  {
    id: generateRandomString(),
    name: "Constitution",
    svg_icon: MenuSvg.familyconstitution,
    to: "/familybook/constitution",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  // {
  //   id: generateRandomString(),
  //   name: "Family Users",
  //   svg_icon: MenuSvg.DoubleProfile_Svg,
  //   to: "/familybook/users",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   name: "Family Health Check",
  //   svg_icon: MenuSvg.familyhealthcheck,
  //   to: "/familybook/health_check_invite_new",
  //   has_children: false,
  //   product_code: ["TECTALIK_PMS"],
  //   screen_codeflag: ["SCN_BUSINESS_HEALTH_CHECK"],
  //   module_codeflag: ["FINANCIAL"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   name: "Social Media",
  //   svg_icon: MenuSvg.socialmedia,
  //   to: "/familybook/Family_Socialmedia",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
];


const TicketMasters_Child_ARR = [
  // {
  //   id: generateRandomString(),
  //   name: "Ticket Category",
  //   to: "/familybook/ticket_category",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_TICKET_CATEGORY"],
  //   module_codeflag: ["MASTERS"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  {
    id: generateRandomString(),
    name: "Service Category",
    to: "/familybook/service_category",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_TICKET_CATEGORY"],
    module_codeflag: ["MASTERS"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Service",
    to: "/familybook/service",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_TICKET_CATEGORY"],
    module_codeflag: ["MASTERS"],
    underline: false,
    isnonadmintoshow: true,
  },
];


// Masters with nested popup submenus (like BoardPAGE style)
const Masters_Child_ARR = [
  // {
  //   id: generateRandomString(),
  //   name: "Global",
  //   has_children: true,
  //   underline: false,
  //   isnonadmintoshow: true,
  //   children: [...FamilyBook_Masters_Child_ARR]
  // },
  {
    id: generateRandomString(),
    name: "Family Masters",
    has_children: true,
    underline: false,
    isnonadmintoshow: true,
    children: [...FamilyMasters_Child_ARR]
  },
  {
    id: generateRandomString(),
    name: "Ticket Masters",
    has_children: true,
    underline: false,
    isnonadmintoshow: true,
    children: [...TicketMasters_Child_ARR]
  }
];



// Forums Sub Menu Items
const Forums_Child_ARR = [
  {
    id: generateRandomString(),
    name: "Meetings",
    svg_icon: MenuSvg.meeting,
    to: "/familybook/family_meetings_landing",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Forums",
    svg_icon: MenuSvg.forum,
    to: "/familybook/Family_Forms",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  // {
  //   id: generateRandomString(),
  //   name: "Tasks",
  //   svg_icon: MenuSvg.task,
  //   to: "/familybook/MyTasks",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  {
    id: generateRandomString(),
    name: "Tasks",
    has_children: true,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
    children: [...TaskMasters_Child_ARR]
  },
  {
    id: generateRandomString(),
    name: "Tickets",
    has_children: true,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
    children: [...Tickets_Child_ARR]
  },
  {
    id: generateRandomString(),
    name: "Votes & Polls",
    svg_icon: MenuSvg.vote,
    to: "/polls",
    product_code: ["TECTALIK_CHCK"],
    screen_codeflag: ["SCN_POLLS"],
    module_codeflag: ["MASTERS"],
    has_children: false,
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "DMS",
    svg_icon: MenuSvg.dms,
    to: "/familybook/document_repository",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
];

const Financials_Child_ARR = [
  // {
  //   id: generateRandomString(),
  //   name: "Family Meetings",
  //   svg_icon: MenuSvg.meeting,
  //   to: "/familybook/family_meetings_landing",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   name: "Family Office",
  //   svg_icon: MenuSvg.members,
  //   to: "/familybook/family_office",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   name: "Forums",
  //   svg_icon: MenuSvg.forum,
  //   to: "/familybook/Family_Forms",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   name: "Tasks",
  //   svg_icon: MenuSvg.task,
  //   to: "/familybook/MyTasks",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   name: "Tickets",
  //   svg_icon: MenuSvg.ticket,
  //   to: "/familybook/ticket",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   name: "Votes & Polls",
  //   svg_icon: MenuSvg.vote,
  //   to: "/familybook/familyvotes",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   name: "DMS",
  //   svg_icon: MenuSvg.dms,
  //   to: "/familybook/document_repository",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   icon: "mdi-heart-pulse",
  //   name: "Upload Financial",
  //   to: "/Healthcheck_Dashboards_financial",
  //   has_children: false,
  //   product_code: ["TECTALIK_PMS"],
  //   screen_codeflag: ["SCN_BUSINESS_HEALTH_CHECK"],
  //   module_codeflag: ["FINANCIAL"],
  // },
  {
    id: generateRandomString(),
    icon: "mdi-clipboard-pulse-outline",
    name: "Upload Financial",
    to: "/familybook/admin_health_check_homescreen",
    has_children: false,
    product_code: ["TECTALIK_PMS"],
    screen_codeflag: ["SCN_TAKE_HEALTH_CHECK"],
    module_codeflag: ["FINANCIAL"],
  },
  // {
  //   id: generateRandomString(),
  //   icon: "mdi-heart-pulse",
  //   name: "Financial Dashboard",
  //   to: "/Healthcheck_Dashboards_operational",
  //   has_children: false,
  //   product_code: ["TECTALIK_PMS"],
  //   screen_codeflag: ["SCN_BUSINESS_HEALTH_CHECK"],
  //   module_codeflag: ["FINANCIAL"],
  // },
  {
    id: generateRandomString(),
    icon: "mdi-heart-pulse",
    name: "Financial Dashboard",
    to: "/familybook/Healthcheck_Dashboards_financial",
    has_children: false,
    product_code: ["TECTALIK_PMS"],
    screen_codeflag: ["SCN_BUSINESS_HEALTH_CHECK"],
    module_codeflag: ["FINANCIAL"],
  },
  {
    id: generateRandomString(),
    name: "Health Check",
    svg_icon: MenuSvg.familyhealthcheck,
    to: "/familybook/health_check_invite_new",
    has_children: false,
    product_code: ["TECTALIK_PMS"],
    screen_codeflag: ["SCN_BUSINESS_HEALTH_CHECK"],
    module_codeflag: ["FINANCIAL"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
   id: generateRandomString(),
   name: "Actual",
   child: true,
   svg_icon: MenuSvg.familyhealthcheck,
   to: "/familybook/actual_new",
   screen_code: ["CREATE_MASTERS"],
   product_code: ["TECTALIK_PMS"],
   screen_codeflag: ["SCN_ACTUAL"],
   module_codeflag: ["FINANCIAL"],
  },
];

const Timeline_Child_ARR = [
  {
    id: generateRandomString(),
    name: "News Feed",
    svg_icon: MenuSvg.socialmedia,
    to: "/familybook/Family_Socialmedia",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  // {
  //   id: generateRandomString(),
  //   name: "Family Meetings",
  //   svg_icon: MenuSvg.meeting,
  //   to: "/familybook/family_meetings_landing",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   name: "Family Office",
  //   svg_icon: MenuSvg.members,
  //   to: "/familybook/family_office",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   name: "Forums",
  //   svg_icon: MenuSvg.forum,
  //   to: "/familybook/Family_Forms",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   name: "Tasks",
  //   svg_icon: MenuSvg.task,
  //   to: "/familybook/MyTasks",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   name: "Tickets",
  //   svg_icon: MenuSvg.ticket,
  //   to: "/familybook/ticket",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   name: "Votes & Polls",
  //   svg_icon: MenuSvg.vote,
  //   to: "/familybook/familyvotes",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
  // {
  //   id: generateRandomString(),
  //   name: "DMS",
  //   svg_icon: MenuSvg.dms,
  //   to: "/familybook/document_repository",
  //   has_children: false,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  // },
];

// Settings Sub Menu Items
const Settings_Child_ARR = [
  {
    id: generateRandomString(),
    name: "Roles",
    svg_icon: MenuSvg.role,
    to: "/familybook/role",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Users",
    svg_icon: MenuSvg.DoubleProfile_Svg,
    to: "/familybook/users",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Password Portal",
    has_children: false,
    icon: "mdi-lock-reset",
    underline: false,
    isnonadmintoshow: true,
    to: "/familybook/password_portal",
    screen_code: ["CREATE_USERS"],
    product_code: ["TECTALIK_CHCK", "TECTALIK_TKT", "TECTALIK_PMS"],
    screen_codeflag: ["SCN_PASSWORD_PORTAL"],
    module_codeflag: ["USERS"],
  },
];

const FullSideMENU = [
  {
    id: generateRandomString(),
    name: "Dashboard",
    svg_icon: MenuSvg.DashBoard_SVG,
    to: "/familybook/FamilyDashboard",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Forums",
    svg_icon: MenuSvg.forum,
    has_children: true,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
    show_children: false,
    children: [...Forums_Child_ARR],
  },
  {
    id: generateRandomString(),
    name: "Family",
    svg_icon: MenuSvg.Family_tree,
    has_children: true,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
    show_children: false,
    children: [...Family_Child_ARR],
  },
  {
    id: generateRandomString(),
    name: "Family Office",
    svg_icon: MenuSvg.members,
    to: "/familybook/family_office",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  // {
  //   id: generateRandomString(),
  //   name: "Financials",
  //   svg_icon: MenuSvg.financial,
  //   has_children: true,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  //   show_children: false,
  //   children: [...Financials_Child_ARR],
  // },
  {
    id: generateRandomString(),
    name: "News Feed",
    to: "/familybook/Family_Socialmedia",
    svg_icon: MenuSvg.socialmedia,
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
    // show_children: false,
    // children: [...Timeline_Child_ARR],
  },
  {
    id: generateRandomString(),
    name: "Settings",
    svg_icon: MenuSvg.Setting_Svg,
    has_children: true,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
    show_children: false,
    children: [...Settings_Child_ARR],
  },
  {
    id: generateRandomString(),
    name: "Masters",
    svg_icon: MenuSvg._3DCube_Svg,
    has_children: true,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_FAMILY_MASTERS"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
    children: [...Masters_Child_ARR],
  }
];

// Top Menu List for Card Menu (shown horizontally at top)
const TopMenuList = [];

// Bottom Left Menu List for Card Menu
const BottonLeftMenuList = [
  {
    id: generateRandomString(),
    name: "Dashboard",
    svg_icon: MenuSvg.DashBoard_SVG,
    to: "/familybook/FamilyDashboard",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
  },
  {
    id: generateRandomString(),
    name: "Forums",
    svg_icon: MenuSvg.forum,
    has_children: true,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
    show_children: false,
    children: [...Forums_Child_ARR],
  },
  {
    id: generateRandomString(),
    name: "Family",
    svg_icon: MenuSvg.Family_tree,
    has_children: true,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
    show_children: false,
    children: [...Family_Child_ARR],
  },
  {
    id: generateRandomString(),
    name: "Family Office",
    svg_icon: MenuSvg.members,
    to: "/familybook/family_office",
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
    show_children: false,
  },
  // {
  //   id: generateRandomString(),
  //   name: "Financials",
  //   svg_icon: MenuSvg.financial,
  //   has_children: true,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_HOME"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  //   show_children: false,
  //   children: [...Financials_Child_ARR],
  // },
  {
    id: generateRandomString(),
    name: "News Feed",
    to: "/familybook/Family_Socialmedia",
    svg_icon: MenuSvg.socialmedia,
    has_children: false,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
    // show_children: true,
    // children: [...Timeline_Child_ARR],
  },
  {
    id: generateRandomString(),
    name: "Settings",
    svg_icon: MenuSvg.Setting_Svg,
    has_children: true,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_HOME"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
    show_children: false,
    children: [...Settings_Child_ARR],
  },
  // {
  //   id: generateRandomString(),
  //   name: "Masters",
  //   svg_icon: MenuSvg._3DCube_Svg,
  //   has_children: true,
  //   product_code: ["FAMILY_BOOK"],
  //   screen_codeflag: ["SCN_FAMILY_MASTERS"],
  //   module_codeflag: ["COMMON"],
  //   underline: false,
  //   isnonadmintoshow: true,
  //   show_children: false,
  //   children: [...FamilyMasters_Child_ARR],
  // },

  {
  id: generateRandomString(),
  name: "Masters",
  svg_icon: MenuSvg._3DCube_Svg,
  has_children: true,
  product_code: ["FAMILY_BOOK"],
  screen_codeflag: ["SCN_FAMILY_MASTERS"],
  module_codeflag: ["COMMON"],
  underline: false,
  isnonadmintoshow: true,
  show_children: false,
  children: [...Masters_Child_ARR], 
}

];

// Bottom Right Menu List for Card Menu
const BottonRightMenuList = [
  {
    id: generateRandomString(),
    name: "Family Office Masters",
    // icon: "mdi-monitor-dashboard",
    // blue_icon: require("@/assets/blue-home.png"),
    svg_icon: MenuSvg._3DCube_Svg,
    // to: "/family_masters",
    has_children: true,
    product_code: ["FAMILY_BOOK"],
    screen_codeflag: ["SCN_FAMILY_MASTERS"],
    module_codeflag: ["COMMON"],
    underline: false,
    isnonadmintoshow: true,
    show_children: false,
    children: [...FamilyMasters_Child_ARR],
  },
];

const _Family_MENU_ = {
  TopMenuList,
  BottonLeftMenuList,
  // BottonRightMenuList,
  FullSideMENU,
};

module.exports = _Family_MENU_;
